import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'partners-widget',
    standalone: true,
    imports: [CommonModule],
    template: `
        <section class="partners-section py-4 overflow-hidden"
                 [style.background-color]="backgroundColor">
            
            <div class="slider-container relative w-full overflow-hidden">
                
                <div class="slider-track flex align-items-center">
                    
                    <div class="flex align-items-center flex-shrink-0 gap-8 pl-8">
                        @for(logo of logos; track logo){
                            <div class="slide px-4 md:px-5 cursor-pointer flex-shrink-0">
                                <img [src]="'/assets/img/clientes/' + logo" 
                                     [alt]="logo" 
                                     class="block w-auto partner-logo" style="max-height: 1.5rem" />
                            </div>
                        }
                    </div>

                    <div class="flex align-items-center flex-shrink-0 gap-8 pl-8">
                        @for(logo of logos; track logo){
                            <div class="slide px-4 md:px-5 cursor-pointer flex-shrink-0">
                                <img [src]="'/assets/img/clientes/' + logo" 
                                     [alt]="logo" 
                                     class="block w-auto partner-logo" style="max-height: 1.5rem" />
                            </div>
                        }
                    </div>

                </div>
                
                <div class="absolute top-0 left-0 h-full w-3rem md:w-5rem z-2"
                     [style.background]="'linear-gradient(to right, ' + backgroundColor + ', transparent)'">
                </div>

                <div class="absolute top-0 right-0 h-full w-3rem md:w-5rem z-2"
                     [style.background]="'linear-gradient(to left, ' + backgroundColor + ', transparent)'">
                </div>

            </div>

        </section>
    `,
    styles: [`
        .slider-track {
            /* max-content es CRUCIAL. Fuerza a que la pista mida exactamente 
               lo que miden los logos + sus paddings, ni un pixel más ni menos */
            width: max-content;
            animation: scroll 40s linear infinite; /* Subí a 40s para que sea más elegante */
            
            /* --- iOS / WebKit Fixes --- */
            will-change: transform;
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
            -webkit-perspective: 1000;
            perspective: 1000;
        }

        .slider-track:hover { animation-play-state: paused; }
        
        @keyframes scroll {
            0% { transform: translate3d(0, 0, 0); }
            100% { transform: translate3d(-50%, 0, 0); }
        }

        .partner-logo {
            opacity: 0.8; 
            transition: all 0.3s ease;
            
            /* Previene desaparición en scroll de Safari */
            -webkit-transform: translateZ(0);
            transform: translateZ(0);
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
        }

        .partner-logo:hover {
            opacity: 1;
            transform: scale(1.05) translateZ(0); /* Mantenemos el hack de aceleración en hover */
        }
    `]
})
export class PartnersWidget {
    @Input() backgroundColor: string = '#F2F2F2';

    logos = [
        'agendapro.png', 'belo.png', 'descentraland.png', 'exactly.png', 'fudo.png',
        'jampp.png', 'legalsurf.png', 'mubi.png', 'profound.png',
        'rga.png', 'rootstrap.png', 'scale.png', 'stori.png', 'uber.png', 'rexi.png'
    ];
}